import nonTextBlock from "./comment/component/nonTextBlock";
import updateEditor from "./common/component/updateEditor";

const { addFilter } = wp.hooks;

export const addFilters = () => {
  addFilter("editor.BlockEdit", "mdComment/nontext-block", nonTextBlock);
  addFilter("editor.BlockEdit", "md/update-editor", updateEditor);
};
